var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.70381 20.3635L17.7401 15.1324V6.8598L8.70381 12.0912V20.3635Z",
    fill: "#C9974B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5897 8.02641V7.73889L8.70421 12.0914V12.3785L12.5534 13.2575L21.5897 8.02641Z",
    fill: "#BF8937"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.615 8.54846L8.70459 12.0913V20.3635L2.615 16.8408V8.54846Z",
    fill: "#AB7835"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.65947 16.1233L8.08875 17.5419V19.1721L5.65947 17.7572V16.1233Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.23512 10.5024L3.23985 11.7608L3.81952 12.0914L3.81516 10.833L4.1048 10.9982L3.52187 9.75952L2.94511 10.3371L3.23512 10.5024Z",
    fill: "#471D1D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.08018 10.003L5.95823 10.4956L5.97643 12.4979L5.08018 11.9634V10.003Z",
    fill: "#C2BFB4"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M5.89912 16.5309L5.99847 16.5907V17.6861L5.89912 17.6262V16.5309Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M6.10491 16.6509L6.20425 16.7108V17.8057L6.10491 17.7459V16.6509Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M6.31033 16.7708L6.41003 16.8306V17.9259L6.31033 17.8661V16.7708Z",
    fill: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M6.51536 16.8904L6.61506 16.9503V18.0456L6.51536 17.9858V16.8904Z",
    fill: "black"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M6.72151 17.0105L6.82084 17.0703V18.1657L6.72151 18.1058V17.0105Z",
    fill: "black"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M6.92653 17.1298L7.02586 17.1896V18.2849L6.92653 18.2251V17.1298Z",
    fill: "black"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M7.13194 17.25L7.23164 17.3098V18.4048L7.13194 18.345V17.25Z",
    fill: "black"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M7.33734 17.3696L7.43668 17.4295V18.5248L7.33734 18.465V17.3696Z",
    fill: "black"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M7.54312 17.4893L7.64246 17.5492V18.6445L7.54312 18.5846V17.4893Z",
    fill: "black"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M7.74854 17.6096L7.84824 17.6694V18.7647L7.74854 18.7049V17.6096Z",
    fill: "black"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M0.363707 6.02343L2.61504 8.83582L11.6514 3.60474L0.363707 5.73628V6.02343Z",
    fill: "#AB7835"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M0.363462 5.73621L2.6148 8.5486L11.6511 3.31714L9.39976 0.504761L0.363462 5.73621Z",
    fill: "#FFDC91"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5897 7.73895L17.7405 6.85999L8.70421 12.0914L12.5534 12.9704L21.5897 7.73895Z",
    fill: "#D6AC54"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6503 3.31708L17.7399 6.85993L8.70359 12.0914L2.614 8.54853L11.6503 3.31708Z",
    fill: "#EBC26C"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M3.33928 8.54886L6.75613 10.5374L8.70291 11.6685L11.6504 9.96454L13.4443 8.92467L17.014 6.85953L11.6504 3.73993L3.33928 8.54886Z",
    fill: "#AB7835"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M3.33978 8.54886L6.75663 10.5374L8.70341 11.6685L11.6509 9.96454V3.73993L3.33978 8.54886Z",
    fill: "#C9974B"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M6.75668 9.7787V10.5376L8.70346 11.6687L11.6509 9.96478L13.4449 8.92491L11.6509 7.88505L10.8431 7.41437L6.75668 9.7787Z",
    fill: "#B39876"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5531 12.9703V13.2574L8.70399 12.3785V12.0913L12.5531 12.9703Z",
    fill: "#AB7835"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBox);
export default __webpack_public_path__ + "static/media/box.b6fc4704a1353af7d339c008f04da675.svg";
export { ForwardRef as ReactComponent };